import { render, staticRenderFns } from "./ArticleBodyMultipage.vue?vue&type=template&id=4a1b3dc2&"
import script from "./ArticleBodyMultipage.vue?vue&type=script&lang=ts&"
export * from "./ArticleBodyMultipage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports